/**
 * Consulta de CNPJ na BrasilAPI (dados públicos da Receita Federal), compartilhada por fornecedores, órgãos e transportadoras.
 * A BrasilAPI limita consultas em sequência: quando recusa (HTTP 429/5xx ou falha de rede, que o navegador mostra
 * como "Failed to fetch"), tenta de novo com espera crescente antes de desistir.
 */
export interface RespostaCnpj {
  razao_social?: string;
  nome_fantasia?: string;
  uf?: string;
  municipio?: string;
  bairro?: string;
  logradouro?: string;
  descricao_tipo_de_logradouro?: string;
  numero?: string;
  complemento?: string;
  cep?: string;
  ddd_telefone_1?: string;
  email?: string | null;
  descricao_situacao_cadastral?: string;
  natureza_juridica?: string;
  codigo_natureza_juridica?: number;
}

export type ResultadoCnpj = { situacao: "ok"; dados: RespostaCnpj } | { situacao: "nao_encontrado" } | { situacao: "indisponivel"; detalhe: string };

const ESPERAS_MS = [1500, 4000, 8000];

const aguardar = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function consultarCnpj(cnpj: string): Promise<ResultadoCnpj> {
  let detalhe = "";
  for (let tentativa = 0; tentativa <= ESPERAS_MS.length; tentativa++) {
    try {
      const resposta = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`, { signal: AbortSignal.timeout(15000) });
      if (resposta.ok) return { situacao: "ok", dados: (await resposta.json()) as RespostaCnpj };
      if (resposta.status === 404) return { situacao: "nao_encontrado" };
      detalhe = `HTTP ${resposta.status}`;
      // 400 e demais erros do pedido não melhoram com nova tentativa.
      if (resposta.status !== 429 && resposta.status < 500) break;
    } catch (e) {
      detalhe = (e as Error).name === "TimeoutError" ? "tempo esgotado" : "serviço recusou a conexão";
    }
    const espera = ESPERAS_MS[tentativa];
    if (espera === undefined) break;
    await aguardar(espera);
  }
  return { situacao: "indisponivel", detalhe };
}
